export default __webpack_public_path__ + "static/media/user.12f1829c.svg";